import { useContext, useEffect, useMemo } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";
import { useNavigate } from "react-router-dom";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import getProducerConfig from "@beeldit/ecommerce/products/configs/producerTableConfig";
import useProducerListAction from "@beeldit/ecommerce/products/actions/list/useProducerListAction";

function ProducerProductsPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useProducerListAction(user, filters);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const { detailsFunction } = useDetailsAction(0, null);

  const initializeFunction = () => {
    navigate(`/panel/${tenantId}/${commerceId}/products/new`);
  };

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getProducerConfig({
        initializeFunction, // We pass the function to initialize a new element (used in the create button)
        indexFunction, // We pass the function to index the table
        prepareRemoveFunction,
        detailsFunction,
        /**newActionsTableConfig**/
      }),
    [initializeFunction, indexFunction, prepareRemoveFunction, detailsFunction]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>{t("products")}</Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {/*{createActionTemplate}*/}
        {/*{editActionTemplate}*/}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default ProducerProductsPage;
